import { X } from 'lucide-react';

/**
 * MarketFilterShell — glass filter container (floats over the hero) with
 * result counter + "clear filters" footer. Children = page-specific controls.
 */
export default function MarketFilterShell({ isDarkMode, isAr, count, total, unitAr, unitEn, hasFilter, onClear, children, testId = 'market-filters' }) {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 -mt-8 relative z-10" data-testid={testId}>
      <div className={`relative rounded-3xl p-4 sm:p-5 overflow-hidden ${isDarkMode ? 'cgm-glass-dark shadow-2xl shadow-black/40' : 'cgm-glass-light shadow-xl shadow-[#1E9BD9]/10'}`}>
        <div className="absolute inset-x-8 top-0 cgm-scanline" />
        {children}
        <div className="mt-4 flex items-center justify-between text-xs">
          <span className={isDarkMode ? 'text-slate-400' : 'text-slate-500'} data-testid={`${testId}-count`}>
            {isAr ? `${count} من أصل ${total} ${unitAr}` : `${count} of ${total} ${unitEn}`}
          </span>
          {hasFilter && (
            <button type="button" onClick={onClear} className="inline-flex items-center gap-1 font-semibold text-[#F59E0B] hover:underline" data-testid={`${testId}-clear`}>
              <X className="h-3.5 w-3.5" />
              {isAr ? 'مسح الفلاتر' : 'Clear filters'}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export function FilterField({ label, children, isDarkMode }) {
  return (
    <div>
      <label className={`block text-xs font-semibold mb-1.5 ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{label}</label>
      {children}
    </div>
  );
}
